import classNames from 'classnames';

import { FeatureContentItem } from './FeatureContentItem';
import type { ComparisonTableGroup } from '../types';

interface Props {
  className?: string;
  group: ComparisonTableGroup;
  tooltipVariant?: 'tooltip' | 'modal';
}

export const FixedComparisonTableSection = ({ group, className, tooltipVariant }: Props) => {
  const renderDisclaimer = () => {
    if (!group.disclaimer) return null;

    if (group.disclaimerLinkText && group.disclaimerLinkUrl) {
      const [before, after] = group.disclaimer.split(group.disclaimerLinkText);

      return (
        <div className="fixed-comparison-table-section__disclaimer">
          {before}
          <a href={group.disclaimerLinkUrl} target="_blank" rel="noopener noreferrer">
            {group.disclaimerLinkText}
          </a>
          {after}
        </div>
      );
    }

    return <div className="fixed-comparison-table-section__disclaimer">{group.disclaimer}</div>;
  };

  return (
    <div className={classNames('fixed-comparison-table-section', className)}>
      {group.features.map((feature) => (
        <FeatureContentItem key={feature.id} {...feature} tooltipVariant={tooltipVariant} />
      ))}
      {renderDisclaimer()}
    </div>
  );
};
